// extracted by mini-css-extract-plugin
module.exports = {"relatedPartsPictureList":"az_Pad","relatedPartPictureWithPlusSign":"az_Qad","relatedPartPlusSign":"az_Rad","relatedPartDeselected":"az_Sad","relatedProductImage":"az_Tad"};